var _rect, _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _path6, _mask4, _path7, _path8, _mask5, _path9, _path10, _mask6, _path11, _path12, _mask7, _path13, _mask8, _path14, _rect2, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 90,
    viewBox: "0 0 100 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 97,
    height: 87,
    fill: "#F0F1F3",
    stroke: "#666770",
    strokeWidth: 3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_5422_3646",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.11108 76.9878H98.8889V88.9155H1.11108V76.9878Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11108 76.9878H98.8889V88.9155H1.11108V76.9878Z",
    fill: "#F0F1F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8889 87.4155H1.11108V90.4155H98.8889V87.4155Z",
    fill: "#666770",
    mask: "url(#path-2-inside-1_5422_3646)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_5422_3646",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 13H99V26H1V13Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13H99V26H1V13Z",
    fill: "#F0F1F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99 23.5H1V28.5H99V23.5Z",
    fill: "#666770",
    mask: "url(#path-4-inside-2_5422_3646)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3_5422_3646",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 26H99V39H1V26Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 26H99V39H1V26Z",
    fill: "#F0F1F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99 36.5H1V41.5H99V36.5Z",
    fill: "#666770",
    mask: "url(#path-6-inside-3_5422_3646)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-4_5422_3646",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 39H99V51H1V39Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 39H99V51H1V39Z",
    fill: "#F0F1F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99 48.5H1V53.5H99V48.5Z",
    fill: "#666770",
    mask: "url(#path-8-inside-4_5422_3646)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-5_5422_3646",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 51H99V64H1V51Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 51H99V64H1V51Z",
    fill: "#F0F1F3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99 61.5H1V66.5H99V61.5Z",
    fill: "#666770",
    mask: "url(#path-10-inside-5_5422_3646)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-6_5422_3646",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.11108 63.976H98.8889V76.988H1.11108V63.976Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.11108 63.976H98.8889V76.988H1.11108V63.976Z",
    fill: "#F0F1F3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8889 74.488H1.11108V79.488H98.8889V74.488Z",
    fill: "#666770",
    mask: "url(#path-12-inside-6_5422_3646)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-7_5422_3646",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 13.0122H35.5556V90.0002H0V13.0122Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0556 13.0122V90.0002H38.0556V13.0122H33.0556Z",
    fill: "#666770",
    mask: "url(#path-14-inside-7_5422_3646)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-8_5422_3646",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2222 13.0122H67.7778V90.0002H32.2222V13.0122Z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2778 13.0122V90.0002H70.2778V13.0122H65.2778Z",
    fill: "#666770",
    mask: "url(#path-16-inside-8_5422_3646)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 13,
    fill: "#666770"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4003 4.975V8.125H13.3003V4.975H22.4003Z",
    fill: "#F0F1F3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3289 4.975V8.125H47.2289V4.975H56.3289Z",
    fill: "#F0F1F3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4717 4.975V8.125H79.3717V4.975H88.4717Z",
    fill: "#F0F1F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablaIcon);
export default __webpack_public_path__ + "static/media/TablaIcon.c5552a526f90355565daae64c9a35022.svg";
export { ForwardRef as ReactComponent };